export default function About() {
    return(
       <div className="container">
         <h1>This is About page</h1>
       </div>
    )

}